module.exports = __webpack_public_path__ + "img/sun.20e1c6be.svg";